var moduleMap = {
	"./AuthContext": () => {
		return Promise.all([__webpack_require__.e(788), __webpack_require__.e(688), __webpack_require__.e(722), __webpack_require__.e(806), __webpack_require__.e(867)]).then(() => (() => ((__webpack_require__(9066)))));
	},
	"./BaseCompanyService": () => {
		return Promise.all([__webpack_require__.e(788), __webpack_require__.e(264)]).then(() => (() => ((__webpack_require__(6883)))));
	},
	"./Firebase": () => {
		return Promise.all([__webpack_require__.e(788), __webpack_require__.e(350)]).then(() => (() => ((__webpack_require__(3350)))));
	},
	"./Dialog": () => {
		return Promise.all([__webpack_require__.e(688), __webpack_require__.e(753), __webpack_require__.e(492)]).then(() => (() => ((__webpack_require__(492)))));
	},
	"./Api": () => {
		return Promise.all([__webpack_require__.e(788), __webpack_require__.e(722), __webpack_require__.e(291)]).then(() => (() => ((__webpack_require__(6291)))));
	},
	"./APIKeyService": () => {
		return Promise.all([__webpack_require__.e(788), __webpack_require__.e(722), __webpack_require__.e(493)]).then(() => (() => ((__webpack_require__(2493)))));
	},
	"./CompanyPicker": () => {
		return Promise.all([__webpack_require__.e(688), __webpack_require__.e(753), __webpack_require__.e(982), __webpack_require__.e(404), __webpack_require__.e(687), __webpack_require__.e(898), __webpack_require__.e(511)]).then(() => (() => ((__webpack_require__(2892)))));
	},
	"./AnnouncementBanner": () => {
		return Promise.all([__webpack_require__.e(788), __webpack_require__.e(688), __webpack_require__.e(753), __webpack_require__.e(404), __webpack_require__.e(824), __webpack_require__.e(588)]).then(() => (() => ((__webpack_require__(2588)))));
	},
	"./SpotlightCard": () => {
		return Promise.all([__webpack_require__.e(788), __webpack_require__.e(753), __webpack_require__.e(910)]).then(() => (() => ((__webpack_require__(910)))));
	},
	"./SpotlightService": () => {
		return Promise.all([__webpack_require__.e(788), __webpack_require__.e(886)]).then(() => (() => ((__webpack_require__(5886)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});